import { useSelector } from 'react-redux';
import { translate, translateNumber } from '../../../i18n';
import { RootState } from '../../../store';
import './CardDirectory.css';

interface ICardDirectoryProps {
    id: number;
    title: string;
    floor: string;
    suite: number;
    category: number;
    index: number;
}

const CardDirectory: React.FC<ICardDirectoryProps> = (props) => {
    const { language } = useSelector((state: RootState) => state.lang);
    const floor = props.floor?.split('|')[2];
    const door = props.floor?.split('|')[0];
    return (
        <button key={props.index} className="CardDirectoryOuter Drop-Shadow">
            <div className="CardDirectoryInner">
                <div className="CardDirectoryName">{props.title}</div>
                <hr className="CardDirectoryLine" />
                <div className="CardDirectoryBottom">
                    <div className="CardDirectoryInfo">
                        {translate('Floor', language)}: {translateNumber(floor, language)}
                    </div>
                    <div className="CardDirectoryInfo">
                        {translate('Suite', language)}: {door}
                    </div>
                </div>
            </div>
        </button>
    );
};

export default CardDirectory;
